/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_History_EmptyInputs */



/**
* | output |
* | --- |
* | "You have not spoken with Wundo here yet." |
*
* @param {Chat_History_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_history_empty = /** @type {((inputs?: Chat_History_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_History_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je sprak hier nog niet met Wundo.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous n'avez pas encore parlé avec Wundo ici.")
	return /** @type {LocalizedString} */ ("You have not spoken with Wundo here yet.")
});